export const MIN_WORDS_FOR_PLAGIARISM_CHECK = 20;
